export default __webpack_public_path__ + "static/media/atomic.b6073349.svg";